import React from 'react'
import styles from '../styles/utils.module.css'

export default function HeadingText() {
  return (
    <>
      <h1 className={styles.headingLg}>
        kaede0902
      </h1>
      <h2 className={styles.headingMd}>
        Kanagawa Univ 4 grade / 2021 graduate
      </h2>
    </>
  )
}
